import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-white border-t border-black" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-10 grid grid-cols-1 md:grid-cols-12 gap-6">
        <div className="md:col-span-5 flex items-center gap-2 flex-wrap">
          <img
            src="/curb-crew-logo.svg"
            alt="Curb Crew"
            className="h-8 w-auto"
          />
          <span className="label-tag text-neutral-500 ml-3">© {new Date().getFullYear()}</span>
        </div>
        <div className="md:col-span-5 text-sm text-neutral-600 leading-relaxed" data-testid="footer-disclaimer">
          Curb Crew is a digital business card service. Cardholders are independent
          service providers. Curb Crew does not match, place or employ anyone.
        </div>
        <div className="md:col-span-2 flex md:justify-end items-start gap-4 flex-wrap">
          <Link to="/twin-matrix" className="label-tag underline text-neutral-600" data-testid="footer-twin-matrix-link">Twin Matrix</Link>
          <Link to="/privacy" className="label-tag underline text-neutral-600" data-testid="footer-privacy-link">Privacy</Link>
          <Link to="/cardholder/register" className="label-tag underline text-neutral-600" data-testid="footer-signup-link">Sign up</Link>
        </div>
      </div>
    </footer>
  );
}
